import { STRIPE_LIST } from "./type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

export const Keys = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/stripe`, config);
    dispatch({
      type: STRIPE_LIST,
      payload: res.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const upadateKey = (val, id) => async (dispatch) => {
  console.log(val, id, "ll");
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  var body = JSON.stringify({
    key: val.key,
  });

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/stripe/${id}`,
      body,
      config
    );
    toast.success("Stripe key added successfully!");
    setTimeout(() => {
      return (window.location.href = "/add-stripe");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
